import type { QueryClient } from "@tanstack/react-query";
import {
  CALCULATION_CYCLE_HISTORY_PAGE_SIZE,
  CALCULATION_CYCLE_STALE_TIME_MS,
} from "@/features/tuition/constants";
import {
  fetchCalculationCyclePage,
  getCalculationCyclesQueryKey,
} from "@/features/tuition/utils/fetch-calculation-cycles";
import { resolveEffectiveTenantNumber } from "@/lib/utils/env/effective-tenant";

export async function prefetchCalculationCyclesGet(
  queryClient: QueryClient,
  accessToken: string,
  tenantId: number = resolveEffectiveTenantNumber(),
  page = 1,
  pageSize = CALCULATION_CYCLE_HISTORY_PAGE_SIZE,
) {
  await queryClient.prefetchQuery({
    queryKey: getCalculationCyclesQueryKey(page, pageSize),
    queryFn: () =>
      fetchCalculationCyclePage(accessToken, tenantId, page, pageSize),
    staleTime: CALCULATION_CYCLE_STALE_TIME_MS,
  });

  return queryClient;
}
